<div fxAlign="row" *ngIf="data">
  <div fxFlex>
    {{data?.message?.text}}
  </div>
  <div fxFlex fxLayoutAlign="end center">
    <button kendoButton [primary]="true" (click)="goToAssessment($event)">View Pretest</button>
  </div>
</div>
